import { create } from "zustand";

export interface CurrentUser {
  fullName: string;
  userName: string;
  roleName: string;
  isActive?: string;
}

interface AuthState {
  displayName: string;
  currentUser: CurrentUser | null;
  setDisplayName: (name: string) => void;
  setCurrentUser: (user: CurrentUser | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  displayName: "",
  currentUser: null,

  setDisplayName: (name) => set({ displayName: name }),
  setCurrentUser: (user) => set({ currentUser: user }),
}));
